
import { Usr_Log } from 'src/app/shared/models/usr_log';
import { DBFun } from 'src/app/shared/models/objects/dbfun';
import { CommonEnums } from 'src/app/shared/common.enums';
import { NavigateUtil } from 'src/app/shared/utils/navigate.util';
import { DBFunGridObject } from 'src/app/shared/models/beans/dbfungridobject';
import { Util } from 'src/app/shared/utils/util';
import { DatabaseWrappersFactory } from 'src/app/shared/databases/database.wrappers.factory';

export class DBFunUtil {
    private static instance: DBFunUtil;

    static getInstance() {
        if (!DBFunUtil.instance) {
            DBFunUtil.instance = new DBFunUtil();
        }

        return DBFunUtil.instance;
    }

    /**
     * DBFunUtil is a singleton class, so use DBFunUtil.getInstance() method instead of creating new DBFunUtil().
     */
    private constructor() {

    }

    getUsr_Log(dBFun: DBFun): Usr_Log {
        let usr_Log: Usr_Log = new Usr_Log();

        usr_Log.obj_Cd = CommonEnums.codes.DBFUN;
        usr_Log.obj_Id = dBFun.dxFun.dxFun_Id;
        usr_Log.nm = dBFun.dxFun.nm;
        usr_Log.objectName = "Expression";
        usr_Log.imageUrl = 'assets/' + dBFun.imageUrl.slice(4, dBFun.imageUrl.length);
        usr_Log.valid_Cd = dBFun.dxFun.valid_Cd;
        usr_Log.valid_Msg = Util.getInstance().getValid_Msg(dBFun.dxFun.valid_Cd);
        usr_Log.mode_Ind = dBFun.mode_Ind;
        usr_Log.change_Ind = dBFun.change_Ind;
        usr_Log.fldr_Id = dBFun.fldr_Id;

        usr_Log.url = NavigateUtil.getInstance()
            .getDBFunUrl(dBFun.dxFun.dxFun_Id, dBFun.fldr_Id, '');

        return usr_Log;
    }

    updateGridObject(dBFunGridObject: DBFunGridObject, dBFun: DBFun): void {
        if (dBFunGridObject.obj_Id != dBFun.dxFun.dxFun_Id) return;

        dBFunGridObject.nm = dBFun.dxFun.nm;
        dBFunGridObject.aliasNm = dBFun.dxFun.aliasNm;
        dBFunGridObject.change_Ind = dBFun.change_Ind;
        dBFunGridObject.valid_Cd = dBFun.dxFun.valid_Cd;
        dBFunGridObject.recExists = dBFun.recExists;
        dBFunGridObject.updateBy = dBFun.dxFun.updateBy;
        dBFunGridObject.updateDt = dBFun.dxFun.updateDt;
        dBFunGridObject.imageUrl = dBFun.imageUrl;
        let databaseWrapper =  DatabaseWrappersFactory.getInstance().getDatabaseWrapper(dBFun.dxFun.dbTyp_Id);
        dBFunGridObject.dbTyp_Nm = databaseWrapper.name;
        
    }

    updateUsr_Log(usr_Log: Usr_Log, dBFun: DBFun): void {
        if (usr_Log.obj_Id != dBFun.dxFun.dxFun_Id) return;

        usr_Log.nm = dBFun.dxFun.nm;
        usr_Log.objectName = "Expression";
        usr_Log.valid_Cd = dBFun.dxFun.valid_Cd;
        usr_Log.valid_Msg = Util.getInstance().getValid_Msg(dBFun.dxFun.valid_Cd);
        let imageUrl = 'assets/' + dBFun.imageUrl.slice(4, dBFun.imageUrl.length)
        usr_Log.imageUrl = imageUrl;
        usr_Log.mode_Ind = dBFun.mode_Ind;
        usr_Log.change_Ind = dBFun.change_Ind;
    }

    copy(dbFuns: Array<DBFun>): Array<DBFun> {
        let dbFunTmp: Array<DBFun> = new Array<DBFun>();

        for (let i: number = 0; i < dbFuns.length; i++) {
            let dbFun: DBFun = dbFuns[i] as DBFun;
            dbFunTmp.push(dbFun.copy())
        }
        return dbFunTmp;
    }

    copyFrom(dbFuns: Array<DBFun>, dbFunsTmp: Array<DBFun>): void {
        let dbFunsMap: Map<number, DBFun> = new Map();

        let dbFunsLength: number = dbFuns.length;
        for (let i: number = 0; i < dbFunsLength; i++) {
            dbFunsMap.set(dbFuns[i].dxFun.dxFun_Id, dbFuns[i]);
        }

        dbFuns.splice(0, dbFuns.length);

        let dbFunsTmpLength: number = dbFunsTmp.length;
        for (let i: number = 0; i < dbFunsTmpLength; i++) {
            let dbFunTmp: DBFun = dbFunsTmp[i] as DBFun;
            let dbFun: DBFun = dbFunsMap.get(dbFunTmp.dxFun.dxFun_Id);
            if (dbFun) {
                dbFun.copyFrom(dbFunTmp);
            } else {
                dbFun = DBFun.parse(dbFunTmp);
            }

            dbFuns.push(dbFun);
        }
    }

    toString(dbFuns: Array<DBFun>): string {
        let str: string = '';

        str += 'dbFuns length: ' + dbFuns.length + ' ';

        for (let i: number = 0; i < dbFuns.length; i++) {
            let dbFun: DBFun = dbFuns[i] as DBFun;
            str += dbFun.toString();
        }

        return str;
    }
}